export enum InvoiceStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface Invoice {
  id: string;
  documentNumber?: string;
  documentType?: string;
  dateIssue?: string;
  customerName?: string;
  customerNumberId?: string | null;
  amountWithTax?: number;
  status?: string; // "Procesado", "Error", "Anulada", etc.
  eInvoiceStatus?: number; // 0 = Procesado, 1 = Error, 5 = Anulada, etc.
  cufe?: string;
  resolution?: string;
  responseCode?: string;
  forceWaitOnEndpoints?: string;
  storeCode?: string;
  billingPoint?: string;
  createdDate?: string;
  lastModifiedDate?: string;

  // Detailed invoice fields (from getInvoiceById)
  payload?: any; // Parsed JSON payload with full invoice details
  response?: string;
  pacResponse?: string;
  billNumber?: string;
  qrCode?: string;
  einvoiceError?: string;
  cufeError?: string;
  responseDate?: string;
  createdBy?: string;
  lastModifiedBy?: string;
  authProtocol?: string;
  cafe?: string;
  xml?: string;

  // Legacy fields (for backward compatibility with mock data)
  invoiceNumber?: string;
  customerRuc?: string;
  date?: string;
  dueDate?: string;
  totalAmount?: number;
  createdAt?: string;
}

export interface InvoiceListResponse {
  invoices: Invoice[];
  total: number;
  page: number;
  pageSize: number;
}

// Email notification types
export interface EmailReceiver {
  Email: string;
  Name: string;
}

export interface EmailAttachments {
  dResponseAuthXML: boolean;
  dResponseXML: boolean;
  dCFe: boolean;
  dCAFE: boolean;
}

export interface ResendEmailRequest {
  electronicInvoiceId: string;
  companyId: string;
  attachments: EmailAttachments;
  receivers: EmailReceiver[];
}
